export default __webpack_public_path__ + "static/media/Left_Arrow.6fda243c.svg";